<template>
    <div>
       <HeaderTeam header="ทีมงานของฉัน" :img_header="header_image" link_back="team"/>
       <MenuMyTeamList/>
       <TeamList/>
    </div>
</template>

<script>
import HeaderImage from '@/assets/icon-team.png'
import HeaderTeam from '@/components/menuadmin/team/teamheader/HeaderTeam.vue'
import MenuMyTeamList from '@/components/menuadmin/team/myteam/MenuMyTeamList.vue'
import TeamList from '@/components/menuadmin/team/myteam/TeamList.vue'
export default {
    name:'myTeam',
    components:{
        HeaderTeam,
        MenuMyTeamList,
        TeamList,
    },
    data(){
        return{
            header_image:HeaderImage
        }
    }
}
</script>